import { mapValues } from 'lodash';
/**
 * Version 30 migrations: add "Hotel requests can be submitted for" setting
 */
export default function v30(website) {
  return {
    ...website,
    eventVersion: 30,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'HotelRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            hotelSetupSettings: {
              ...layoutItem.config.hotelSetupSettings,
              allowedAttendeeTypes: 'invitee'
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
